import { nanoid } from 'nanoid';
import React from 'react';
import CustomAccordion from '../../shared/Custom-Accordion/CustomAccordion';
import MobileNavList from './MobileNavList';

/**
 * @name SubDropdownMenu
 * @description Displays Su bDropdownMenu of nav links
 * @param {object} root0  - destructured object
 * @param {object} root0.nav - Data from Strapi
 * @param {Function} root0.handleExpand - OnClick function for expanding nav list
 * @returns {JSX.Element} ReactJs Element
 */
const SubDropdownMenu = ({ nav, handleExpand }) =>
  nav?.PrimaryNavL2?.map(link => (
    <CustomAccordion
      key={nanoid(8)}
      title={link.title}
      description={<MobileNavList nav={link?.PrimaryNavL3} handleExpand={handleExpand} />}
    />
  ));

SubDropdownMenu.displayName = 'SubDropdownMenu';
export default SubDropdownMenu;
